// extracted by mini-css-extract-plugin
export default {"device":"Device_device__7p5KD","abcd":"Device_abcd__5UN6b","svgIcon":"Device_svgIcon__PsLC6","rotation":"Device_rotation__EI9cg","clicked":"Device_clicked__CYtv4"};